import React, {useState} from "react";
import {
    Box,
    Dialog,
    Typography,
    IconButton,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    Link,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import useLogin from "../../../hooks/login/useLogin";
import {useTranslation} from "react-i18next";
import {PAGE_LOGIN} from "../../../locales/pages/namespaces";
import {LoadingButton} from "@mui/lab";

export default function BrewLoginModal({ open, onClose, onForgotPassword,onSignUp }) {
    const { formik,loading } = useLogin();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation(PAGE_LOGIN)




    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            fullWidth
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 450,
                    maxWidth: isMobile ? "100%" : "95vw",
                    m: isMobile ? 0 : 2,
                    borderRadius: isMobile ? 0 : "20px",
                    bgcolor: "#F0F0F0",
                    overflow: "hidden",
                },
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    p: { xs: 2, sm: 2.5 },
                    pt: { xs: 6, sm: 2.5 },
                    minHeight: isMobile ? "100vh" : "auto",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: { xs: 12, sm: 10 },
                        right: { xs: 12, sm: 10 },
                        width: 42.11,
                        height: 40.88,
                        borderRadius: "30px",
                        bgcolor: "#FBFBFB",
                        "&:hover": { bgcolor: "#FBFBFB" },
                    }}
                >
                    <CloseIcon sx={{ color: "#111111" }} />
                </IconButton>

                <Box
                    component="form"
                    onSubmit={formik.handleSubmit}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 2, sm: 2.5 },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: { xs: 20, sm: 24 },
                            textTransform: "uppercase",
                            color: "#111",
                        }}
                    >
                        {t('Login')}
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1, sm: 0 },
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontSize: { xs: 13, sm: 14 },
                                lineHeight: "120%",
                            }}
                        >
                            {t('Do not have an account?')}
                        </Typography>
                        <Link
                            component="button"
                            type="button"
                            onClick={onSignUp}
                            underline="always"
                            sx={{
                                color: "#E5007E",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontWeight: 700,
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontSize: { xs: 14, sm: 16 },
                                p: 0,
                                textAlign: "left",
                            }}
                        >
                            {t('Sign up here')}
                        </Link>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
                        <TextField
                            {...formik.getFieldProps("username")}
                            fullWidth
                            variant="outlined"
                            size="small"
                            name="username"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.username && Boolean(formik.errors.username)}
                            helperText={formik.touched.username && formik.errors.username}
                            placeholder={t("Username")}
                            InputLabelProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    color: "#111111",
                                    "&.Mui-focused": {
                                        color: "#111111",
                                    },
                                },
                            }}
                            InputProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    "& .MuiInputBase-input": {
                                        py: 1.1,
                                        pl: 1,
                                    },
                                    "& fieldset": {
                                        borderColor: "#111111",
                                        borderWidth: 1,
                                        borderRadius: "4px",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#111111",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#111111",
                                    },
                                },
                            }}
                        />

                        <TextField
                            {...formik.getFieldProps("password")}
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="password"
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            placeholder="Password"
                            InputLabelProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    color: "#111111",
                                    "&.Mui-focused": {
                                        color: "#111111",
                                    },
                                },
                            }}
                            InputProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    "& .MuiInputBase-input": {
                                        py: 1.1,
                                        pl: 1,
                                    },
                                    "& fieldset": {
                                        borderColor: "#111111",
                                        borderWidth: 1,
                                        borderRadius: "4px",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#111111",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#111111",
                                    },
                                },
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1, sm: 0 },
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                        }}
                    >
                        <FormControlLabel
                            control={<Checkbox size="small" />}
                            label={t('Remember me')}
                            sx={{
                                m: 0,
                                "& .MuiTypography-root": {
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontSize: { xs: 14, sm: 16 },
                                },
                            }}
                        />

                        <Link
                            component="button"
                            type="button"
                            onClick={onForgotPassword}
                            underline="always"
                            sx={{
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontSize: { xs: 14, sm: 16 },
                                color: "#000",
                                p: 0,
                                textAlign: "left",
                            }}
                        >
                            {t('Forgot your password?')}
                        </Link>
                    </Box>

                    <LoadingButton
                        loading={loading}
                        type="submit"
                        fullWidth={isMobile}
                        sx={{
                            width: isMobile ? "100%" : 98,
                            height: 37,
                            borderRadius: "120px",
                            bgcolor: "#E5007E",
                            "&:hover": { bgcolor: "#E5007E" },
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: 14,
                            color: "#FCFCFC",
                            textTransform: "none",
                            alignSelf: isMobile ? "stretch" : "flex-start",
                            mt: 0.5,
                        }}
                    >
                        {t('Login')}
                    </LoadingButton>
                </Box>
            </Box>
        </Dialog>
    );
}


